export default "__VITE_ASSET__CjbbnKeg__"